import { useRegionCookieConsentContext } from '../contexts/cookie-consent'
export default function useScriptsAllowed(): [boolean, boolean] {
  const { consent, regionDetected, bannerRequired } =
    useRegionCookieConsentContext()
  // consent cookie is present but statistics consent hasn't been given
  const dontTrack = consent.necessary && !consent.statistics
  return [
    regionDetected,
    consent.statistics || (regionDetected && !bannerRequired && !dontTrack),
  ]
}
